import { render } from "./HjpDataTable.vue?vue&type=template&id=503d9d36&ts=true"
import script from "@/composables/components/table/HjpDataTableComposable.ts?vue&type=script&lang=ts"
export * from "@/composables/components/table/HjpDataTableComposable.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__